<template>
  <div>
    <Modal :title="editProjectName ? `编辑租户「${editProjectName}」` : `添加租户`" v-model="editProjectModal" width="800">
      <Alert show-icon type="error" v-if="editProjectError">{{ editProjectErrorMsg }}</Alert>
      <Form ref="editProjectForm" :model="editProjectForm" :rules="editProjectRules">
        <FormItem label="名称" style="width: 100%" prop="name">
          <Input v-model="editProjectForm.name" />
        </FormItem>
        <FormItem label="描述" style="width: 100%" prop="description">
          <Input v-model="editProjectForm.description" type="textarea" :rows="4" placeholder="（选填）" />
        </FormItem>
        <FormItem label="激活" style="width: 100%" prop="enabled">
          <i-switch v-model="editProjectForm.enabled" size="large">
            <span slot="open">可用</span>
            <span slot="close">禁用</span>
          </i-switch>
        </FormItem>
      </Form>
      <div slot="footer">
        <Button type="primary" style="margin-right: 8px" @click="editProjectSubmit" :loading="editProjectSubmitting">提交</Button>
        <Button @click="editProjectModal = false">取消</Button>
      </div>
    </Modal>
    <Card shadow class="content">
      <div class="main">
        <Alert v-if="error" show-icon type="error">
          获取数据失败
          <a style="float: right" v-on:click="getProjects"><Icon type="md-refresh" size="18" /></a>
        </Alert>
        <div v-else>
          <Row>
            <h4 style="float: left">租户列表</h4>
            <div style="float: right;" class="align-right">
              <Button :style="{marginRight: '10px', marginBottom: '10px'}" icon="md-refresh" @click="getProjects">刷新</Button>
              <Button
                @click="openEditModal"
                :style="{marginBottom: '10px'}"
                icon="md-add">添加租户</Button>
            </div>
          </Row>
          <Table
            :loading="tableLoading"
            ref="table"
            :data="projects"
            :columns="columns">
            <template slot="ActionMenu" slot-scope="props">
              <ActionMenu :project="props.detail" :users="users" :roles="roles" v-on:callback="getProjects"></ActionMenu>
            </template>
          </Table>
        </div>
      </div>
    </Card>
  </div>
</template>

<script>
import { getPrivateCloudProject, editPrivateCloudProject } from '@/api/private-cloud/project'
import { getPrivateCloudAllUser } from '@/api/private-cloud/user'
import { getPrivateCloudRole } from '@/api/private-cloud/role'
import ActionMenu from './components/ActionMenu'

export default {
  components: {
    ActionMenu
  },
  data () {
    return {
      error: false,
      projects: [],
      users: [],
      roles: [],
      columns: [
        {
          title: '租户名称',
          key: 'name',
          align: 'center',
          minWidth: 150
        },
        {
          title: '描述',
          key: 'description',
          align: 'center',
          minWidth: 200
        },
        {
          title: '租户ID',
          key: 'id',
          align: 'center',
          minWidth: 200
        },
        {
          title: '状态',
          key: 'enabled',
          align: 'center',
          minWidth: 100,
          render: (h, params) => {
            if (params.row.enabled) {
              return h('Tag', {
                attrs: {
                  color: 'cyan'
                }
              }, '激活')
            } else {
              return h('Tag', {
                attrs: {
                  color: 'red'
                }
              }, '禁用')
            }
          }
        },
        {
          title: '操作',
          align: 'center',
          width: 170,
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {
                  type: 'warning',
                  size: 'small'
                },
                style: {
                  marginRight: '5px'
                },
                on: {
                  click: () => {
                    this.openEditModal(params.row)
                  }
                }
              }, '编辑'),
              this.$refs.table.$scopedSlots.ActionMenu({
                detail: params.row
              })
            ])
          }
        }
      ],
      tableLoading: false,
      // 编辑租户
      editProjectModal: false,
      editProjectSubmitting: false,
      editProjectError: false,
      editProjectErrorMsg: null,
      editProjectName: null,
      editProjectForm: {
        id: '',
        name: '',
        description: '',
        enabled: true
      },
      editProjectRules: {
        name: { required: true, message: '名称是必填的', trigger: 'blur' },
        enabled: { required: true, message: '', type: 'boolean', trigger: 'change' }
      }
    }
  },
  created: function () {
    this.getProjects()
    this.getUsers()
    this.getRoles()
  },
  methods: {
    getProjects () {
      this.tableLoading = true
      getPrivateCloudProject().then(res => {
        this.projects = res.data.projects
        this.error = false
        this.tableLoading = false
      }).catch(res => {
        this.error = true
        this.tableLoading = false
        console.error(res.response)
      })
    },
    // 获取用户
    getUsers () {
      getPrivateCloudAllUser().then(res => {
        this.users = res.data
      }).catch(res => {
        console.error('获取用户列表失败')
        console.error(res.response)
      })
    },
    // 获取所有角色
    getRoles () {
      getPrivateCloudRole().then(res => {
        this.roles = res.data.roles
      }).catch(res => {
        console.error('获取角色列表失败')
        console.error(res.response)
      })
    },
    openEditModal (row) {
      if (row) {
        this.editProjectForm = {
          id: row.id,
          name: row.name,
          description: row.description,
          enabled: row.enabled
        }
        this.editProjectName = row.name
      } else {
        this.editProjectForm.id = ''
        this.editProjectName = null
      }
      this.editProjectModal = true
    },
    editProjectSubmit () {
      this.$refs.editProjectForm.validate((valid) => {
        if (valid) {
          this.editProjectSubmitting = true
          editPrivateCloudProject(this.editProjectForm, this.editProjectForm.id).then(res => {
            this.editProjectSubmitting = false
            this.editProjectError = false
            this.editProjectErrorMsg = null
            this.editProjectModal = false
            this.getProjects()
            this.$Notice.success({title: '操作成功'})
          }).catch(res => {
            this.editProjectSubmitting = false
            console.error(res.response)
            this.$Notice.error({title: '操作失败'})
            this.editProjectErrorMsg = res.response.data
            this.editProjectError = true
          })
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
